<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">选择指标名称</div>
            <el-select v-model="checkNameId" clearable placeholder="请选择指标名称" style="width:100%;margin-right: 5px;">
              <el-option
                  v-for="item in list_name"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="24" class="item">
            <div class="label">名称</div>
            <el-input v-model="add_name" placeholder="请输入名称"></el-input>
          </el-col>

          <el-col :span="12" class="item">
            <div class="label">内容</div>
            <el-input v-model="add_content" type="textarea" rows="5" placeholder="请输入内容"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">标准</div>
            <el-input v-model="add_standard" type="textarea" rows="5" placeholder="请输入标准"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">分值</div>
            <el-input v-model="add_score" placeholder="请输入分值"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="add_sort" placeholder="请输入排序"></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: ['list_name'],
  data() {
    return {

      loading: false,

      add_name:'',
      add_sort:0,
      add_content:'',
      add_standard:'',
      add_score:0,

      checkNameId:'',

    }
  },
  methods: {
    init(){

      this.add_name = '';
      this.add_sort = 0;
      this.add_content = '';
      this.add_standard = '';
      this.add_score = 0;

      this.checkNameId = '';

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.checkNameId === ''){
        this.$message("选择指标名称");
        return;
      }
      if(this.add_name === ''){
        this.$message("输入名称");
        return;
      }
      if(this.add_score === ''){
        this.$message("输入分值");
        return;
      }
      if(this.add_content === ''){
        this.$message("输入内容");
        return;
      }
      if(this.add_standard === ''){
        this.$message("输入标准");
        return;
      }
      if(this.add_sort === ''){
        this.$message("输入排序");
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'CheckNameItem/AdmAdd',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),

          name: this.add_name,
          content: this.add_content,
          standard: this.add_standard,
          score: this.add_score,
          sort:this.add_sort,

          checkNameId:this.checkNameId,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },



  }
}
</script>

